/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD8TotalResponseDto } from '../../models/backend-d-8-total-response-dto';

export interface GetTotalDashboardsD8TotalGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;

  /**
   * Начало периода YYYY-MM-DD
   */
  from?: string | null;

  /**
   * Конец периода YYYY-MM-DD
   */
  to?: string | null;

  /**
   * month — помесячно, year — годовая агрегация
   */
  granularity?: 'month' | 'year';
}

export function getTotalDashboardsD8TotalGet(
  http: HttpClient,
  rootUrl: string,
  params: GetTotalDashboardsD8TotalGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD8TotalResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getTotalDashboardsD8TotalGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD8TotalResponseDto>;
    }),
  );
}

getTotalDashboardsD8TotalGet.PATH = '/dashboards/d8/total';
